module.exports = __webpack_public_path__ + "static/home-e68180c99b6d2c533b13155bb6335c4a.png";